import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { cn } from '../../lib/utils';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About Us',
    href: '/about'
  }, {
    name: 'Membership',
    href: '/membership'
  }, {
    name: 'Events',
    href: '/events'
  }, {
    name: 'Charity',
    href: '/charity'
  }, {
    name: 'Team',
    href: '/team'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname !== '/') return false;
    return location.pathname.startsWith(path);
  };
  return <header className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60" data-id="element-67">
      <div className="container mx-auto px-4 md:px-6" data-id="element-68">
        <div className="flex h-20 items-center justify-between" data-id="element-69">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-id="element-70">
            <img src="https://cdn.magicpatterns.com/uploads/stkewdFoDLsveAsLMC6296/favi__logo.png" alt="Khyber Medical Association UK Logo" className="h-14 w-14 object-contain" data-id="element-71" />
            <div className="flex flex-col" data-id="element-72">
              <span className="text-lg font-serif font-bold leading-none text-primary-900" data-id="element-73">
                KMA UK
              </span>
              <span className="text-xs text-gray-500" data-id="element-74">
                Khyber Medical Association
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6 lg:space-x-8" data-id="element-75">
            {navigation.map(item => <Link key={item.name} to={item.href} className={cn('text-sm font-medium transition-colors hover:text-primary-700', isActive(item.href) ? 'text-primary-700 font-semibold' : 'text-gray-600')} data-id="element-76">
                {item.name}
              </Link>)}
            <Link to="/membership" data-id="element-77">
              <Button size="sm" variant="primary" data-id="element-78">
                Join Membership
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-79">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-80" /> : <Menu className="h-6 w-6" data-id="element-81" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden border-t border-gray-100 bg-white" data-id="element-82">
          <div className="container mx-auto px-4 py-4 space-y-4" data-id="element-83">
            {navigation.map(item => <Link key={item.name} to={item.href} className={cn('block text-base font-medium py-2', isActive(item.href) ? 'text-primary-700' : 'text-gray-600')} onClick={() => setIsMenuOpen(false)} data-id="element-84">
                {item.name}
              </Link>)}
            <div className="pt-4" data-id="element-85">
              <Link to="/membership" onClick={() => setIsMenuOpen(false)} data-id="element-86">
                <Button className="w-full" data-id="element-87">Join Membership</Button>
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}